function removeMenuByIds(menu, idsToRemove) {
  const removeIds = Array.isArray(idsToRemove) ? idsToRemove : [idsToRemove];

  return menu
    .filter((item) => !removeIds.includes(item.id))
    .map((item) => {
      const newItem = { ...item };
      if (newItem.subMenu) {
        newItem.subMenu = item.subMenu ? removeMenuByIds(item.subMenu, removeIds) : undefined;
      }
      return newItem;
    });
}

function removeMenuById(menu, idToRemove) {
  return removeMenuByIds(menu, [idToRemove]);
}

export { removeMenuById, removeMenuByIds };
